import { Empty, Popover } from "antd";
import { MessageOutlined } from "@ant-design/icons";
import Message from "./Message";
import "../../styles/notifications.css";
import { useContext, useMemo, useState } from "react";
import { LangContext } from "../../contexts/Contexts";

const messagesMenuCopy = {
  en: {
    title: "Messages",
    empty: "You have no messages",
    showLess: "Show fewer messages",
    viewAll: "View all messages",
  },
  es: {
    title: "Mensajes",
    empty: "No tienes mensajes",
    showLess: "Mostrar menos mensajes",
    viewAll: "Ver todos los mensajes",
  },
};

export const MessagesMenu = ({ messages }) => {
  const maxMessagesToShow = 5;
  const [showAll, setShowAll] = useState(false);
  const [open, setOpen] = useState(false);
  const { lang } = useContext(LangContext);
  const copy = useMemo(
    () => messagesMenuCopy[lang?.toLowerCase?.().startsWith("es") ? "es" : "en"],
    [lang],
  );

  const messagesContent = (
    <div className="notifications-pop messages-panel">
      <div className="notifications-panel__header">
        <h3>{copy.title}</h3>
      </div>

      <div className="messages-panel__list">
        {messages?.length ? (
          messages
            .slice(0, showAll ? messages.length : maxMessagesToShow)
            .map((message, index) => (
              <div key={message.idUsuarioOrigen ?? message.idChat ?? index}>
                <Message message={message} onNavigate={() => setOpen(false)} />
              </div>
            ))
        ) : (
          <div className="notifications-panel__empty">
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={copy.empty}
            />
          </div>
        )}
      </div>

      {messages?.length > maxMessagesToShow ? (
        <button
          type="button"
          className="notifications-panel__footer-link"
          onClick={() => setShowAll(!showAll)}
        >
          {showAll ? copy.showLess : copy.viewAll}
        </button>
      ) : null}
    </div>
  );

  return (
    <Popover
      content={messagesContent}
      trigger={"click"}
      open={open}
      onOpenChange={setOpen}
      destroyTooltipOnHide={true}
      zIndex={10060}
      overlayClassName="notifications-popover-overlay"
      getPopupContainer={() => document.body}
    >
      <button
        type="button"
        className="notifications-action-button"
        aria-label={copy.title}
      >
        {/* Icono de antd y no la imagen PNG anterior: un PNG no toma el color
            por CSS, y este boton comparte fila con otros tres iconos que si lo
            hacen. Con el icono vectorial los cuatro se pintan y se dimensionan
            igual. */}
        <MessageOutlined className="notifications-action-icon" />
      </button>
    </Popover>
  );
};
